//import { Component, Input, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


import { Component, Input, Output, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, HeaderService, NavigationService, AuthService, UserService } from '@base/shared/services';
import { ProjectsService } from '@eyrus/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { get, omit, orderBy } from 'lodash';
import { EyrusWarningModalComponent } from '@base-shared/components/warning-modal/warning-modal.component';
import { DailyLogsService } from '@eyrus/modules/daily-logs/daily-logs.service';
import * as moment from 'moment';


@Component({
  selector: 'walkthrough-new-note-content',
  templateUrl: './new-note-modal.component.html',
  styleUrls: [
    './new-note-modal.component.sass',
    '../../../../../modules/daily-logs/submitter/notes/notes.component.sass'
  ]
})

export class NewNoteWalkthroughModalContent {

  public accountId: string;
  public contractId: string;
  public data: any;
  public walkthroughSectionNoteId: string;
  public contractWalkthroughId: string;
  public calendarDate: string;
  public contracts: any;
  public noteData: any;
  public queryParams: any;
  public loading: Boolean = false;
  public album: any = {};
  public sectionId: any;
  public noteForm: FormGroup;
  public formMode: string = 'save';

  private rootContractId = this.accountService.account.contract.contractId;

  currentNote: any;
  readOnly: Boolean = false;
  private subscriptions: any = {};
  private isQuick: Boolean = false;
  isMobile: Boolean = false;

  @Input() currentNoteId;
  //@Input() contractWalkthroughId;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private navigator: Location,
    private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private api: ApiRequestsService,
    private helpers: HelpersService,
    private translate: TranslateService,
    private authService: AuthService,
    private accountService: UserService
  ) { }

  /** TODO: use note.component */
  async ngOnInit() {

    this.sectionId = this.activeRoute.snapshot.paramMap.get('id');
    this.accountId = this.authService.accountId;
    //this.contractId = this.activeRoute.snapshot.params.projectId;
    this.walkthroughSectionNoteId = this.activeRoute.snapshot.params.walkthroughSectionNoteId || this.data.walkthroughSectionNoteId;

    this.contractWalkthroughId = this.data.contractWalkthroughId;

    this.calendarDate = this.activeRoute.snapshot.queryParams.calendarDate;
    this.queryParams = this.activeRoute.snapshot.queryParams;

    await this.listContracts();

    if (this.walkthroughSectionNoteId) {
      this.formMode = 'edit';
      this.contractWalkthroughsNote();
    } else {
      this.bootstrapForm({});
    }
  }



  async listContracts() {
    const payload = { parentContractId: this.rootContractId };
    try {
      const res: any = await this.api.contracts.getListByParentId(payload).toPromise();

      this.contracts = orderBy(res.data, 'displayName') || [];
      this.contracts.unshift({
        contractId: '',
        displayName: this.translate.instant('none')
      });

      return this.contracts;
    } catch (error) {
      this.helpers.errorMessage(error);
    }
  }


  /**
   * Get Note by Note Id
   * @params(contractWalkthroughId, walkthroughSectionNoteId)
   */
  contractWalkthroughsNote() {
    this.api.walkthroughServices.getContractWalkthroughNote(this.contractWalkthroughId, this.walkthroughSectionNoteId)
      .then(result => {
        this.noteData = result.contractWalkthroughNoteListItem || {};
        this.bootstrapForm(this.noteData);
      })
      .catch(err => {
        this.helpers.errorMessage(err);
        this.cancel();
      });
  }



  /**
   * create / edit current note
   */
  saveOrUpdate({ value, valid }: { value: any, valid: boolean }) {
    if (!valid) {
      this.helpers.setFormError(this.noteForm, false);
      this.noteForm.controls['relatedContract'].setErrors(null);
      return;
    }

    this.loading = true;
    let payload;
    if (this.formMode === 'edit') {
      payload = [
        {
          'op': 'replace',
          'path': '/note',
          'value': value.note
        }
      ];

      payload.push(
        {
          'op': 'replace',
          'path': '/referenceContractId',
          'value': `${get(value, 'relatedContract.contractId') || ''}`
        }
      );

      this.editForm(payload);
    } else {
      payload = {
        note: value.note,
        referenceContractId: `${get(value, 'relatedContract.contractId') || ''}`
      };
      this.saveForm(payload);
    }

  }

  editForm(payload) {
    this.api.walkthroughServices.pathContractWalkthroughNote(this.contractWalkthroughId, this.walkthroughSectionNoteId, payload)
      .then(result => {
        const _label = 'common.successfullyUpdated';
        const _title = this.translate.instant('notes.note');
        const _msg = this.translate.instant(_label, { section: _title });

        this.helpers.successMessage('', _msg);
        this.cancel();
      })
      .catch(err => {
        this.loading = false;
        this.helpers.errorMessage(err);
        this.helpers.setFormError(this.noteForm, false);
      });
  }

  saveForm(payload) {
    this.api.walkthroughServices.createContractWalkthroughNotes(this.contractWalkthroughId, payload)
      .then(result => {
        const _label = 'common.successfullyCreated';
        const _title = this.translate.instant('notes.note');
        const _msg = this.translate.instant(_label, { section: _title });

        this.helpers.successMessage('', _msg);
        this.cancel();
      })
      .catch(err => {
        this.loading = false;
        this.helpers.errorMessage(err);
        this.helpers.setFormError(this.noteForm, false);
      });
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1.contractId === o2.contractId;
  }

  /**
   * Initialize photo form
   */
  private bootstrapForm(data?: any) {
    const contract = this.contracts.find(item => {
      return item.contractId === get(data, 'referenceContract.contractId') || '';
    });

    this.noteForm = this.formBuilder.group({
      note: [data.note || '', [Validators.required]],
      relatedContract: [contract || '']
    });
  }


  goBack() {
    this.closeModal();
  }

  /**
   * Cancel note creation / edition
   */
  cancel() {
    this.closeModal({});
  }

  /**
   * Close current Modal
   * @param {[type]} result [description]
   */
  closeModal(result?) {
    this.activeModal.close(result);
  }

}
